<template>
  <div class="dashboard">
    <row>
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
          <div class="info-box-content text-center">
            <span class="info-box-text">{{
              $t("dashboard.notification_due_index")
            }}</span>
            <span class="label label-warning info-box-title">{{
              project_scheduler.next_start_input_duration.days
            }}</span>
            <span class="label label-warning info-box-title">{{
              project_scheduler.next_start_input_duration.hours
            }}</span>
            <div>
              <span class="info-box-number">{{ $t("dashboard.day") }}</span>
              <span class="info-box-number">{{ $t("dashboard.hour") }}</span>
            </div>
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
          <div class="info-box-content text-center">
            <span class="info-box-text">{{
              $t("dashboard.notification_due_export_invoice")
            }}</span>
            <span class="label label-warning info-box-title">{{
              project_scheduler.current_end_input_duration.days
            }}</span>
            <span class="label label-warning info-box-title">{{
              project_scheduler.current_end_input_duration.hours
            }}</span>
            <div>
              <span class="info-box-number">{{ $t("dashboard.day") }}</span>
              <span class="info-box-number">{{ $t("dashboard.hour") }}</span>
            </div>
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->

      <!-- fix for small devices only -->
      <div class="clearfix visible-sm-block"></div>

      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
          <div class="info-box-content text-center">
            <span class="info-box-text">{{
              $t("dashboard.notification_due_cycle_pay")
            }}</span>
            <span class="label label-warning info-box-title">{{
              project_scheduler.current_end_payment_duration.days
            }}</span>
            <span class="label label-warning info-box-title">{{
              project_scheduler.current_end_payment_duration.hours
            }}</span>
            <div>
              <span class="info-box-number">{{ $t("dashboard.day") }}</span>
              <span class="info-box-number">{{ $t("dashboard.hour") }}</span>
            </div>
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
          <div class="info-box-content text-center">
            <span class="info-box-text">{{
              $t("dashboard.notification_due_maintenance")
            }}</span>
            <span class="label label-warning info-box-title">{{
              project_scheduler.current_end_maintainance_duration.days
            }}</span>
            <span class="label label-warning info-box-title">{{
              project_scheduler.current_end_maintainance_duration.hours
            }}</span>
            <div>
              <span class="info-box-number">{{ $t("dashboard.day") }}</span>
              <span class="info-box-number">{{ $t("dashboard.hour") }}</span>
            </div>
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->
    </row>
    <row>
      <div class="col-md-6"><ApartmentPerMonthLineChart /></div>
      <div class="col-md-3"><ApartmentPerMonthPieChart /></div>
      <div class="col-md-3"><RentalApartmentPerMonthPieChart /></div>
    </row>
    <row>
      <div class="col-md-6"><StatisticalService></StatisticalService></div>
      <div class="col-md-3"><StatisticalInvoice></StatisticalInvoice></div>
      <div class="col-md-3">
        <StatisticalPaymentLate></StatisticalPaymentLate>
      </div>
    </row>
  </div>
</template>

<script>
//import VAChart from 'va/components/VAChart'
import ApartmentPerMonthLineChart from "./ApartmentPerMonthLineChart";
import ApartmentPerMonthPieChart from "./ApartmentPerMonthPieChart";
import RentalApartmentPerMonthPieChart from "./RentalApartmentPerMonthPieChart";
import StatisticalService from "./StatisticalService";
import StatisticalInvoice from "./StatisticalInvoice";
import StatisticalPaymentLate from "./StatisticalPaymentLate";
import { mapGetters, mapActions } from "vuex";
import utils from '@/lib/utils'

export default {
  name: "DashBoard",
  data() {
    return {
      project_scheduler: {
        next_start_input_duration: {
          days: `00`,
          hours: `00`
        },
        current_end_input_duration: {
          days: `00`,
          hours: `00`
        },
        current_end_payment_duration: {
          days: `00`,
          hours: `00`
        },
        current_end_maintainance_duration: {
          days: `00`,
          hours: `00`
        }
      }
    };
  },
  watch: {
    GET_ACTIVATED_PROJECT: function() {
      this.getProjetScheduler();
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACTIVATED_PROJECT"
    ])
  },
  methods: {
    ...mapActions([
      "GET_PROJECT_SCHEDULER_DETAIL"
    ]),
    getProjetScheduler: function() {
      const projectId = utils.getProjectSession();
      if (projectId) {
        this.GET_PROJECT_SCHEDULER_DETAIL({ id: projectId }).then(
          function(res) {
            let project_scheduler = res.data;
            this.project_scheduler.next_start_input_duration.days = this.paddingDateTime(
              project_scheduler.next_start_input_duration.days
            );
            this.project_scheduler.next_start_input_duration.hours = this.paddingDateTime(
              project_scheduler.next_start_input_duration.hours
            );
            this.project_scheduler.current_end_input_duration.days = this.paddingDateTime(
              project_scheduler.current_end_input_duration.days
            );
            this.project_scheduler.current_end_input_duration.hours = this.paddingDateTime(
              project_scheduler.current_end_input_duration.hours
            );
            this.project_scheduler.current_end_payment_duration.days = this.paddingDateTime(
              project_scheduler.current_end_payment_duration.days
            );
            this.project_scheduler.current_end_payment_duration.hours = this.paddingDateTime(
              project_scheduler.current_end_payment_duration.hours
            );
          }.bind(this)
        );
      }
    },
    paddingDateTime: function(number, width) {
      let i_width = width || 2;
      let w = i_width + 1;
      return (new Array(w).join("0") + number).slice(i_width * -1);
    }
  },
  components: {
    //'va-chart': VAChart
    ApartmentPerMonthLineChart,
    ApartmentPerMonthPieChart,
    RentalApartmentPerMonthPieChart,
    StatisticalService,
    StatisticalInvoice,
    StatisticalPaymentLate
  },
  mounted() {
    this.getProjetScheduler();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-box-text {
  text-transform: none;
  font-size: 12px;
}

.info-box-content {
  margin-left: 0px;
  line-height: 35px;
}

.info-box-number {
  display: inline;
  font-size: 14px;
  padding: 12px;
}

.info-box-title {
  font-size: 25px;
  color: black !important;
  background: linear-gradient(
    to top,
    #9c9e9f 0%,
    #9c9e9f 50%,
    #adada7 50%,
    #ccc1c1 100%
  );
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/DashBoard.vue